import React from "react";

import {
  AspectRatioBox,
  Card,
  CardTitle,
  CardDescription,
  CardContent,
} from "@greeter/matter";

import css from "./CreateCard.module.scss";
import { IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";
import { doNothing } from "@greeter/util";
import { AspectRatios } from "@greeter/matter";

const CardCover: React.FC<
  React.PropsWithChildren & { ratio: AspectRatios }
> = ({ ratio, ...props }) => (
  <AspectRatioBox ratio={ratio}>
    <div {...props} className={css.CardCover} />
  </AspectRatioBox>
);
export type CreateCardProps = {
  title: string;
  subTitle?: string;
  ratio?: AspectRatios;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
};

export function CreateCard({
  onClick = doNothing,
  title,
  subTitle,
  ratio = "4:3",
  style,
  ...props
}: CreateCardProps) {
  return (
    <Card onClick={onClick} style={style} className={css.CreateCard} {...props}>
      <div className={css.CardHeader}>
        <CardCover ratio={ratio}>
          <IonIcon className={css.AddIcon} icon={add} />
        </CardCover>
      </div>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{subTitle}</CardDescription>
      </CardContent>
    </Card>
  );
}
